import { render, staticRenderFns } from "./authorCmp.vue?vue&type=template&id=45c765ae&scoped=true&"
import script from "./authorCmp.vue?vue&type=script&lang=js&"
export * from "./authorCmp.vue?vue&type=script&lang=js&"
import style0 from "./authorCmp.vue?vue&type=style&index=0&id=45c765ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c765ae",
  null
  
)

export default component.exports